import React, { useState } from "react";

export default function SocialPostForm() {
  const [postContent, setPostContent] = useState("");
  const [platforms, setPlatforms] = useState([]);
  const [scheduleTime, setScheduleTime] = useState("");

  const handlePlatformChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setPlatforms([...platforms, value]);
    } else {
      setPlatforms(platforms.filter((p) => p !== value));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const postData = {
      content: postContent,
      platforms,
      schedule_time: scheduleTime,
    };

    // send to PHP backend (posts.php)
    fetch("http://localhost/backend/posts.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(postData),
    })
      .then((res) => res.json())
      .then((data) => {
        alert("Post scheduled successfully!");
        console.log(data);
      })
      .catch((err) => console.error("Error:", err));
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-xl font-semibold mb-4">Create Social Media Post</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Content Box */}
        <textarea
          value={postContent}
          onChange={(e) => setPostContent(e.target.value)}
          placeholder="Write your post here..."
          className="w-full border rounded-lg p-3 h-32"
          required
        ></textarea>

        {/* Platform Selection */}
        <div>
          <label className="font-medium">Choose Platforms:</label>
          <div className="flex gap-4 mt-2">
            <label>
              <input
                type="checkbox"
                value="facebook"
                onChange={handlePlatformChange}
              />{" "}
              Facebook
            </label>
            <label>
              <input
                type="checkbox"
                value="twitter"
                onChange={handlePlatformChange}
              />{" "}
              Twitter
            </label>
            <label>
              <input
                type="checkbox"
                value="instagram"
                onChange={handlePlatformChange}
              />{" "}
              Instagram
            </label>
            <label>
              <input
                type="checkbox"
                value="linkedin"
                onChange={handlePlatformChange}
              />{" "}
              LinkedIn
            </label>
          </div>
        </div>

        {/* Schedule Date/Time */}
        <div>
          <label className="font-medium">Schedule Time:</label>
          <input
            type="datetime-local"
            value={scheduleTime}
            onChange={(e) => setScheduleTime(e.target.value)}
            className="w-full border rounded-lg p-2"
            required
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          Schedule Post
        </button>
      </form>
    </div>
  );
}
